<template>
  <v-app>
    <div class="app-bg"></div>
    <v-content>
      <AppBar v-if="mobileScreen" />
      <div class="frame-container flex-center-content">
        <div class="mobile-frame">
          <AppBar v-if="!mobileScreen" />
          <router-view />
          <CookiePolicy v-if="showCookie" @cookieAction="onCookieAction" />
        </div>
        <MenuCard />
      </div>
    </v-content>
  </v-app>
</template>

<script>
import { MenuCard, AppBar, CookiePolicy } from './components';

export default {
  name: 'App',

  components: {
    AppBar,
    MenuCard,
    CookiePolicy
  },

  data: () => ({
    showCookie: false,
    mobileScreen: window.innerWidth <= 499
  }),

  created() {
    if(!localStorage.getItem('cookie-action'))
      this.showCookie = true;
  },

  mounted() {
    window.addEventListener('resize', () => {
      this.mobileScreen = window.innerWidth <= 499;
      this.$store.commit('SET_IS_SMALL', window.innerWidth <= 360);
    })
  },

  methods: {
    onCookieAction() {
      this.showCookie = false;
      localStorage.setItem('cookie-action', true);
    }
  },

  watch: {
    "$route": () => {
      document.querySelector('.mobile-frame').scrollTo(0,1);
      window.scrollTo(0,1);
    }
  }
};
</script>

<style scoped>
#app {
  font-family: Montserrat;
}
.app-bg {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;

  filter: blur(5px);
  -webkit-filter: blur(5px);
}
.mobile-frame {
  width: 411px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
  position: relative;
  background-color: #EDF2F5;
}
.frame-container {
  /* min-width: 100vw; */
  min-height: 100vh;
}
.mobile-frame {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.mobile-frame::-webkit-scrollbar { 
  display: none;
}
@media screen and (min-width: 500px) {
  .mobile-frame {
    width: calc(411px * 0.92);
    height: calc(100vh * 0.9) !important;
    max-height: calc(100vh * 0.9) !important;
  }
}
@media screen and (max-width: 499px) {
  body {
    background-image: unset;
    background-color: #020B2D !important;
  }
  .mobile-frame {
    width: 100%;
    min-height: 100vh;
  }
  .frame-container {
    align-items: flex-start;
  }
}
</style>